import { createAction } from '@reduxjs/toolkit';
import { name } from './slice';

export const goToOrderAction = createAction(`${name}/GO_TO_ORDER`);
